<template>
  <div class="p-personMemo mt30" :id="`memo-${memo.id}`">
    <div class="p-personMemo-speechBubbleHeader bgc-yellow">
      <div class="p-personMemo-speechBubbleHeader-inner bgc-white plr15 d-f ai-c gap5">
        <div class="ptb10" v-if="memo.recruit">
          <p><span class="d-ib bgc-yellow bdrs-max c-white fw-b plr10">{{ memo.recruit.businessgroup_and_name }}</span></p>
          <div class="d-f ai-c gap5 mt5">
            <p class="fw-b fz115">
              <a v-if="memo.recruit.recruiting && !memo.recruit.company_deleted" :href="recruitPath(memo.recruit.id)" class="under-line hov">{{ memo.recruit.company.name }}</a>
              <span v-else>{{ memo.recruit.company.name }}</span>
            </p>
            <span class="d-ib bgc-white bd-black80 c-black80 bdrs-max fw-b plr10" v-if="!memo.recruit.recruiting || memo.recruit.company_deleted">掲載終了</span>
          </div>
          <p class="fw-b fz85 c-black80">{{ memo.recruit.businessgroup_and_name }}</p>
        </div>
        <p class="p-personMemo-speechBubbleHeader-createdAt fz85 fw-b c-black80">生成日：{{ formatDate(memo.created_at) }}</p>
      </div>
      <span class="p-personMemo-speechBubbleHeader-triangle"></span>
    </div>
    <div class="mt20">
      <textarea class="u-input-textarea u-input-autoFlexTextarea js-autoFlexTextarea" rows="6" name="text" v-model="memo.text"></textarea>
      <div class="d-f jc-fe mt20">
        <button type="submit" class="u-reset-button bgc-key bdrs-max c-white d-if jc-c ai-c fw-b" style="width: 90px; height: 30px;" @click="onSaveClick">
          <span v-show="!nowSending"><span class="d-if jc-c ai-c gap5"><i class="u-icon-save"></i>保存</span></span>
          <span class="rotate" v-show="nowSending"><i class="u-icon-refresh"></i></span>
        </button>
      </div>
    </div>
    <button type="button" class="p-personMemo-removeButton bgc-black100 js-modalToggle" data-modal="deleteMemo-confirmationModal" @click="onDeleteClick"><i class="u-icon-cross c-white"></i></button>
  </div>
</template>

<script>
  export default {
    props: {
      propMemo: { type: Object, required: true },
    },
    data() {
      return {
        nowSending: false,
        memo: this.propMemo,
      }
    },
    created() {
      this.memo = this.propMemo;
    },
    methods: {
      formatDate(isoString) {
        const date = new Date(isoString);
        if (Number.isNaN(date.getTime())) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
      },
      recruitPath(recruitId) {
        return `/person/companies/${recruitId}/match_score`;
      },
      async onSaveClick() {
        this.nowSending = true;
        this.$emit('update', {
          memoId: this.memo.id,
          text: this.memo.text,
          onFinally: () => {
            this.nowSending = false;
          },
        })
      },
      async onDeleteClick() {
        this.$emit('delete', {
          memoId: this.memo.id,
          onFinally: () => {},
        });
      },
    }
  }
</script>

<style scoped>
.rotate {
  animation: spin 3s linear infinite;
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
</style>
